<template>
  <div id="payments-plan-popup">
    <vx-card title="">
      <div class="mt-6 mb-6">
        <div class="flex md:items-end items-center justify-between flex-wrap">
          <!--p class="lg:inline-flex bold black text-3xl mr-4">Tus semillas y girasoles </p-->

          <div class="flex justify-between items-end flex-grow">
            <div class="flex flex-wrap">
              <p v-if="isMounted && isMobileScreen"
                class="px-6 py-2 mb-3 text-primary bold border-2 border-primary border-solid rounded-lg">Total de
                movimientos: {{ plans.length }}</p>

              <vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer mr-6 items-per-page-handler">
                <div
                  class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">Mostrando {{ currentItemsPage * itemsPerPage - (itemsPerPage - 1) }} - {{
                    plans.length - currentItemsPage * itemsPerPage > 0 ? currentItemsPage * itemsPerPage :
                      plans.length }} de {{ queriedItems }}</span>
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="itemsPerPage = it" :key="it">
                    <span>{{ it }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <p v-if="isMounted && !isMobileScreen"
                class="px-6 py-2 text-primary bold border-2 border-primary border-solid rounded-lg">{{ plans.length
                }}
                movimientos en total</p>
            </div>
          </div>
        </div>
      </div>

      <vs-table ref="paymentsPlanTable" :data="currentPlans" :max-items="itemsPerPage" stripe noDataText="No hay registros disponibles">
        <template slot="thead">
          <vs-th class="bold" sort-key="number">No.</vs-th>
          <vs-th class="bold">Día de Pago</vs-th>
          <vs-th class="bold">Pago</vs-th>
          <vs-th class="bold">Saldo Inicial</vs-th>
          <vs-th class="bold">Capital<br>Amortizado</vs-th>
          <vs-th class="bold">Intereses</vs-th>
          <vs-th class="bold">IVA</vs-th>
          <!-- <vs-th class="bold">Pen.</vs-th> -->
          <!-- <vs-th class="bold">Intereses<br>Moratorios</vs-th> -->
          <vs-th class="bold">Comisión<br>RedGirasol</vs-th>
          <vs-th class="bold">Saldo Final</vs-th>
          <vs-th class="bold"></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].number">
              {{ tr.number }}
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{ humanDateFormat(tr.date) }}
            </vs-td>
            <vs-td :data="data[indextr].payment">
              {{ explicitMoneyFormat(tr.payment) }}
            </vs-td>
            <vs-td :data="data[indextr].first">
              {{ explicitMoneyFormat(tr.first) }}
            </vs-td>
            <vs-td :data="data[indextr].amorti">
              {{ explicitMoneyFormat(tr.amorti) }}
            </vs-td>
            <vs-td :data="data[indextr].interest">
              {{ explicitMoneyFormat(tr.interest) }}
            </vs-td>
            <vs-td :data="data[indextr].iva">
              {{ explicitMoneyFormat(tr.iva) }}
            </vs-td>
            <!-- <vs-td :data="data[indextr].penalty">
              {{ explicitMoneyFormat(tr.penalty) }}
            </vs-td> -->
            <!-- <vs-td :data="data[indextr].moratorium">
              {{ explicitMoneyFormat(tr.moratorium) }}
            </vs-td> -->
            <vs-td :data="data[indextr].investor_comission">
              {{ explicitMoneyFormat(tr.investor_comission) }}
            </vs-td>
            <vs-td :data="data[indextr].final">
              {{ explicitMoneyFormat(tr.final) }}
            </vs-td>
            <vs-td :data="data[indextr].paid">
              {{ tr.paid ? 'Pagado' : '-' }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

        <br>
        <vx-pagination :total="totalPages" v-model="currentx"></vx-pagination>

      <div class="vx-row mt-4" v-if="canRefund">
        <div class="vx-col lg:w-3/4 w-full">
          Las fechas del plan de pagos durante la etapa de fondeo son estimados y podrían variar al iniciar
          el proceso de instalación. Para un reembolso de tus fondos, da clic
          <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="onRefundClick">aquí.</router-link></span>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import VxPagination from "@/vx-components/vx-pagination/VxPagination";

export default {
  name: "PaymentsPlan",
  props: {
    projectId: { type: [String,Number], required: true},
    canRefund: { type: Boolean, default: false},
  },
  components: {VxPagination},
  mixins: [dateHelper, formatHelper],
  data(){
    return {
      plans: [],
      parameter: [],
      payments: [],
      itemsPerPage: 10,
      itemsPerPageDefinitions: [10,20],
      isMounted: false,
      failed: false,
      currentx: 1,
      mobileScreen: 576,
    }
  },
  async mounted() {
    this.showLoading(true)
    this.isMounted = false
    await this.getPaymentsInfo();
    this.isMounted = true
    this.showLoading(false)
  },
  computed: {
    totalPages() {
      return Math.ceil(this.plans.length / this.itemsPerPage);
    },
    currentItemsPage() {
      return this.currentx;
    },
    currentPlans() {
      let cmin = ((this.currentx - 1) * this.itemsPerPage);
      let cmax = (cmin + this.itemsPerPage);
      return this.plans.slice(cmin, cmax);
    },
    queriedItems() {
      return this.plans.length
    },
    isMobileScreen() {
      return this.$store.state.windowWidth <= this.mobileScreen
    },
  },
  methods: {
    async getPaymentsInfo(){
      try{
        const response = await axios.get(`api/inversionista/inversiones/resumen/${this.$props.projectId}/pagos`);
        this.plans = response.data.plans;
        this.payments = response.data.payments;
        this.parameter = response.data.parameter;
      }
      catch (e) {
        this.failed = true;
      }
    },
    async onRefundClick(){
      this.$emit('on-refund-click');
    }
  }
}
</script>

<style scoped>

</style>